import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { HERO_STATS, TYPEWRITER_TEXT_KEY } from "../landingData";

const LandingHero = () => {
  const { t } = useTranslation("common");
  const [typedText, setTypedText] = useState("");
  const typewriterText = t(TYPEWRITER_TEXT_KEY);

  useEffect(() => {
    let index = 0;
    let timeoutId;
    setTypedText("");

    const typeWriter = () => {
      if (index <= typewriterText.length) {
        setTypedText(typewriterText.slice(0, index));
        index += 1;
        timeoutId = window.setTimeout(typeWriter, 60);
      }
    };

    typeWriter();

    return () => window.clearTimeout(timeoutId);
  }, [typewriterText]);

  return (
    <section className="hero">
      <div className="hero-badge">
        <span className="pulse-dot"></span>
        {t("Real-time Odoo API Generation — NO CODE")}
      </div>
      <h1>
        {t("The API Layer Your")}
        <br />
        <span className="gradient-text">{t("Odoo Deserves")}</span>
      </h1>
      <p className="hero-sub">
        {t(
          "Generate real-time APIs for any Odoo instance. Connect to Odoo SH, Enterprise, or self-hosted — powered by AWS infrastructure built for scale."
        )}
      </p>
      <div className="typewriter">
        <span>{typedText}</span>
        <span className="cursor">|</span>
      </div>
      <div className="hero-cta">
        <Link to="/login" className="btn-primary">
          {t("Generate Your First API →")}
        </Link>
        <a href="#docs" className="btn-ghost">
          {t("View Documentation")}
        </a>
      </div>
      <div className="stats">
        {HERO_STATS.map(({ value, labelKey }) => (
          <div key={labelKey} className="stat">
            <span className="stat-val">{value}</span>
            <span className="stat-label">{t(labelKey)}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default LandingHero;
